export class EnablerItemUtil {
  static mergeEnablerIds(projectIds: number[] | null | undefined, productIds: number[] | null | undefined): string[] {
    const result: string[] = [];
    if (projectIds) {
      result.push(...projectIds.map(id => "PROJECT-" + id));
    }
    if (productIds) {
      result.push(...productIds.map(id => "PRODUCT-" + id));
    }
    return result;
  }

  static separateEnablerItems(enablerItemIds: any[], availableEnablerItems: any[]): {
    projectIds: number[],
    productIds: number[]
  } {
    const projectIds: number[] = [];
    const productIds: number[] = [];

    if (enablerItemIds && Array.isArray(enablerItemIds)) {
      enablerItemIds.forEach((itemId: any) => {
        const item = availableEnablerItems.find(ei => ei.idFormatted == itemId);
        if (item) {
          if (item.type === 'PROJECT') {
            projectIds.push(item.id);
          } else if (item.type === 'PRODUCT') {
            productIds.push(item.id);
          }
        }
      });
    }

    return {projectIds, productIds};
  }
}